import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

const propTypes = {
  /**
   * Title of the field. Must be a FormattedMessage id
   */
  title: PropTypes.string,
  /**
   * Value of the field
   */
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  /**
   * Class of the container wrapper
   */
  containerClassName: PropTypes.string,
  /**
   * Class to style the title
   */
  titleClassName: PropTypes.string,
}

const displayValue = (value) => {
  const none = (
    <span className="text-color-secondary">
      <FormattedMessage id="GENERAL.NONE" />
    </span>
  )

  if (Array.isArray(value)) {
    if (!value?.length) {
      return none
    }

    return value.map((item, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <div className="mb-1" key={index}>
        {item}
      </div>
    ))
  }

  if (!value && value !== 0) {
    return none
  }

  return value
}

/**
 * Field with title that displays anything that is passed as value
 * If an array is passed will render each option in one line
 */
function ReadOnlyText(props) {
  const { title = null, value = null, containerClassName = '', titleClassName = '' } = props ?? {}

  return (
    <div className={clsx('mb-3', containerClassName)}>
      {title && (
        <p className={clsx('mb-2 text-bold', titleClassName)}>
          <FormattedMessage id={title} />
        </p>
      )}

      <div>{displayValue(value)}</div>
    </div>
  )
}

ReadOnlyText.propTypes = propTypes

export default ReadOnlyText
